<template>
  <v-file-input
    :loading="loading"
    ref="upload"
    multiple
    :rules="rules"
    :accept="accept"
    filled
    dense
    color="primary"
    prepend-inner-icon="mdi-attachment"
    prepend-icon=""
    hint="Max size 2mb (.png, .jpg, .pdf, .doc)"
    :persistent-hint="true"
    @change="change"
  >
    <template v-slot:selection="{ index, text }">
      <v-chip v-if="index < 2" color="primary" dark label small>
        {{ text }}
      </v-chip>

      <span
        v-else-if="index === 2"
        class="overline grey--text text--darken-3 mx-2"
      >
        +{{ selectedFiles.length - 2 }} File(s)
      </span>
    </template>
  </v-file-input>
</template>

<script>
import { storage } from '@/firebaseConfig'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    accept: {
      type: String,
      default: '.doc,.docx,.png,.jpeg,.pdf',
    },
    relativePath: {
      type: String,
      default: 'uploads',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    reservedNames: {
      type: Array,
      default: () => [],
      validator: (prop) => prop.every((e) => typeof e === 'string'),
    },
  },
  data() {
    return {
      rules: [
        (files) =>
          !files ||
          !files.some((file) => file.size > 2097152) ||
          'File size must not exceed 2 MB!',
        (files) =>
          !files ||
          !files.find((e) => this.reservedNames.includes(e.name)) ||
          `File with name '${
            files.find((e) => this.reservedNames.includes(e.name)).name
          } already exists'`,
      ],
      selectedFiles: this.value ?? [],
    }
  },
  computed: {
    ...mapGetters(['companyId', 'currentUser']),
    fullUploadPath() {
      return `companies/${this.companyId}/${this.relativePath}`
    },
    storageRef() {
      return storage.ref().child(this.fullUploadPath)
    },
  },
  methods: {
    ...mapActions(['showError']),
    change(files) {
      this.$emit('change', files)
    },
  },
}
</script>


